// extracted by mini-css-extract-plugin
export var container = "_jr-0";
export var segment = "_jr-2";
export var segmentActive = "_jr-3";
export var track = "_jr-1";